






import { Component, Vue } from "vue-property-decorator";
import ApdSurveilansList from "@/components/ppi/apd-surveilans/ApdSurveilansList.vue";

@Component({
  components: { ApdSurveilansList }
})
export default class ApdSurveilansPage extends Vue {}
